/**
 * Product card behaviour (snippets/card.liquid):
 * - <card-quick-add>: the size tap adds through addToCart (/cart/add.js, then cart:added opens the bag)
 *   instead of leaving the page; Escape or a tap elsewhere closes the picker.
 * - A card link names its colour field `card-field` at click time, so the field morphs into the
 *   PDP's field (docs/contracts.md, page transitions). Only the clicked card is ever named.
 */
import { addToCart, defineElement } from '@wispaire/global';

const Base = globalThis.HTMLElement ?? class {};

export class CardQuickAdd extends Base {
  connectedCallback() {
    this.details = this.querySelector('details');
    this.status = this.querySelector('[role="status"]');
    this.querySelector('form').addEventListener('submit', (event) => this.submit(event));
    this.details.addEventListener('toggle', () => {
      if (this.details.open) this.status.textContent = '';
    });
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !this.details.open) return;
      this.details.open = false;
      this.details.querySelector('summary').focus();
    });
  }

  async submit(event) {
    const button = event.submitter;
    if (!button?.value) return;
    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    try {
      await addToCart([{ id: Number(button.value), quantity: 1 }], { source: this });
      if (this.details) this.details.open = false;
      if (this.status) this.status.textContent = this.status.dataset.added;
    } catch (error) {
      if (this.status) this.status.textContent = error.message;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }
}

defineElement('card-quick-add', CardQuickAdd);

const doc = globalThis.document;
let named;
doc?.addEventListener('click', (event) => {
  const target = event.target;
  if (!target?.closest) return;

  for (const open of doc.querySelectorAll('card-quick-add details[open]')) {
    if (!open.contains(target)) open.open = false;
  }

  const link = target.closest('.card__link');
  if (!link || event.defaultPrevented) return;
  if (named) named.style.viewTransitionName = '';
  named = link.querySelector('[data-card-field]');
  if (named) named.style.viewTransitionName = 'card-field';
});
